import Swiper from "swiper";

class Gallery {
    constructor() {
        this.init();
    }

    init() {
        this.slider();
    }

    slider() {
        this.swiper = new Swiper(".mySwiperGallery", {
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: ".gallery_swiper-button-next",
                prevEl: ".gallery_swiper-button-prev",
            },
            loop: true,

            breakpoints: {
                150: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                }

            }
        });
    }
}

new Gallery();
